module.exports = __webpack_public_path__ + "static/cloudscopy-ea091c0f5420aaa40f534575b07172c6.png";